import { Sparkles } from "lucide-react";

export default function EmptyState({
  icon: Icon = Sparkles,
  title,
  description,
  action,
  testId = "empty-state",
}) {
  return (
    <div data-testid={testId} className="text-center py-12 px-6">
      <div className="w-14 h-14 rounded-full bg-void/60 border border-gold/25 flex items-center justify-center mx-auto mb-4">
        <Icon className="w-6 h-6 text-gold" strokeWidth={1.5} />
      </div>
      <h3 className="font-display text-xl mb-2">{title}</h3>
      {description && (
        <p className="text-neutral-500 text-sm max-w-sm mx-auto leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
  );
}
